@let data = timeData();

@if (showIcon() || !showTooltip()) {
  @if (data) {
    <span class="text-overflow">
      {{ displayedTime() }}
      @if (showIcon() && !data?.isEmpty) {
        <span
          class="ml-2 cursor-help text-info"
          tooltipClass="tooltip-lg text-start"
          [container]="container()"
          [ngbTooltip]="tooltipContent"
          [ngClass]="iconClass()"
          [placement]="placement()"
          (mouseenter)="infoIconHoverHandler(true)"
          (mouseleave)="infoIconHoverHandler(false)"></span>
      }
      <ng-template #tooltipContent>
        @if (needWaitLoadTimezone() && isNullTimezone()) {
          <span class="loader loader-lg"></span>
        }
        @if (!needWaitLoadTimezone() || !isNullTimezone()) {
          @if (!hideAgentTime()) {
            <div>{{ 'shared:time.agent' | i18next }}: {{ data.agent?.time }} {{ data.agent?.utc }}</div>
          }
          <div>{{ 'shared:time.provider' | i18next }}: {{ data.provider?.time }} {{ data.provider?.utc }}</div>
          <div>{{ 'shared:time.local' | i18next }}: {{ data.local?.time }} {{ data.local?.utc }}</div>
        }
      </ng-template>
    </span>
  }
} @else {
  @if (data) {
    <span
      class="text-overflow cursor-help"
      tooltipClass="tooltip-lg text-start"
      [container]="container()"
      [ngbTooltip]="tooltipContent"
      [placement]="placement()">
      {{ displayedTime() }}
      <ng-template #tooltipContent>
        @if (needWaitLoadTimezone() && isNullTimezone()) {
          <span class="loader loader-lg"></span>
        }
        @if (!needWaitLoadTimezone() || !isNullTimezone()) {
          @if (!hideAgentTime()) {
            <div>{{ 'shared:time.agent' | i18next }}: {{ data.agent?.time }} {{ data.agent?.utc }}</div>
          }
          <div>{{ 'shared:time.provider' | i18next }}: {{ data.provider?.time }} {{ data.provider?.utc }}</div>
          <div>{{ 'shared:time.local' | i18next }}: {{ data.local?.time }} {{ data.local?.utc }}</div>
        }
      </ng-template>
    </span>
  }
}
